import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/shCommitment/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shCommitment'
  }
]
